export default function prefersReducedMotion(): boolean {
  if (!(`matchMedia` in window)) {
    return true;
  }
  return window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
}
